// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"17cbeaf54ddc4032a72b","293":"3f42794e61aceb6a90ec","518":"e18d8503e3eeb7bf09aa","779":"d035eaf5039b10c0e31d"}[chunkId] + ".js";
};